<template>
  <div class="drug-box">
    <div class="img-item">
      <img src="https://oss.aqdpay.com/appweb/activeimg/nfcActive/1.png" alt="">
      <div v-if="showShareIcon" class="share-box" @click="handleShare">
        <img src="https://oss.aqdpay.com/appweb/activeimg/nfcActive/share.png" alt="">
      </div>
    </div>
    <div class="img-item">
      <img src="https://oss.aqdpay.com/appweb/activeimg/nfcActive/2.png" alt="">
    </div>
    <div class="img-item">
      <img src="https://oss.aqdpay.com/appweb/activeimg/nfcActive/3.png" alt="">
      <div class="gif-box">
        <img src="https://oss.aqdpay.com/appweb/activeimg/nfcActive/nfc.gif" alt="">
      </div>
    </div>
    <div v-if="isApp" class="img-item-2">
      <img @click="goNfc" src="https://oss.aqdpay.com/appweb/activeimg/nfcActive/button.png" alt="">
    </div>
    <div v-if="!isApp" class="img-item-2">
      <img @click="goApp" src="https://oss.aqdpay.com/appweb/activeimg/nfcActive/button.png" alt="">
    </div>
    <share-sheet :showShare="showShare" @share="handleShareContent" @cancleShare="handleCancelShare"></share-sheet>
  </div>
</template>
<script>
import shareSheet from '@/components/shareSheet'

export default {
  components: {
    shareSheet
  },
  data () {
    return {
      isApp: false,
      sourceApp: null,
      showShareIcon: false,
      showShare: false
    }
  },
  created () {
    if (this.getDevice()) {
      this.isApp = true
    }
    this.sourceApp = this.$route.query.sourceApp
    if (this.sourceApp === 'qdt') {
      this.isApp = true
      this.showShareIcon = false
    } else {
      this.showShareIcon = true
    }
  },
  methods: {
    getDevice () {
      const ua = window.navigator.userAgent
      if (ua.indexOf('pkg/bjqd') > -1) {
        return true
      }
      return false
    },
    goNfc () {
      if (this.sourceApp === 'qdt') {
        let data = {
          finishCurrentPage: 1,
          appId: '100299999',
          authorize: 0,
          androidGoPage: '/ReactNative/QDTHomeActivity',
          iosGoPage: 'QDTViewController',
          appType: 1,
          goPage: 'Main'
        }
        // window.ReactNativeWebView.postMessage('sss')
        window.ReactNativeWebView.postMessage(JSON.stringify(data))
      } else {
        const data = {
          addToolbar: 1,
          appId: '100299999',
          authorize: 0,
          androidGoPage: '/ReactNative/QDTHomeActivity',
          iosGoPage: 'QDTViewController',
          appType: 0,
          appStartUrl: 'NfcHome'
        }
        dsBridge.call('callNativeViewLifeCycle', {
          ...data
        })
      }
    },
    goApp () {
      if (window._czc) {
        window._czc.push(['_trackEvent', '开通乘车卡推广页', '推广nfc乘车卡', '推广nfc乘车卡', '', '032'])
      }
      window.location.href = 'bjqd://'
      setTimeout(function () {
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
      }, 1200)
    },
    // 分享
    handleShare () {
      this.showShare = true
    },
    handleCancelShare () {
      this.showShare = false
    },
    handleShareContent (type) {
      this.showType = type
      const preFix = window.location.hostname
      console.log(preFix)
      const url = `${preFix}/appweb/nfcActive`
      dsBridge.call('callShareWithType', {
        thirdType: this.showType,
        contentShareType: 3,
        title: '2秒进站！地铁公交超快乘车攻略来袭！',
        content: '“场所码+琴岛通NFC”乘车，地铁公交实现2秒超快进站上车！',
        image: 'https://oss.aqdpay.com/appweb/activeimg/nfcActive/sharewximg.png',
        urlStr: url
      }, function () {})
      this.showShare = false
    }
  }
}
</script>
<style lang="scss" scoped>
.drug-box {
  box-sizing: border-box;
  min-height: 100vh;
  padding-bottom: 80px;
  font-size: 0;
  background: #ecfefe;
}
.img-item {
  position: relative;
  img {
    width: 100%;
  }
}
.img-item-2 {
  position: fixed;
  bottom: 0.5%;
  margin: 10px 0;
  padding: 0 10%;
  img {
    width: 100%;
  }
}
.gif-box {
  position: absolute;
  top: 6%;
  left: 13%;
  width: 75%;
  margin: 0 auto;
  img {
    width: 100%;
  }
}
.share-box {
  position: absolute;
  top: 2.1%;
  right: 3.5%;
  img {
    width: 24px;
    height: 24px;
  }
}
</style>
